<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer style="content-visibility:auto"></app-footer>
